var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagons2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1073,
    height: 1056,
    viewBox: "0 0 1073 1056",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_59_600)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568.5,
    cy: 493.303,
    r: 306.5,
    fill: "#CDFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1143 663.453L123.11 682.034L155.703 662.744L155.296 624.879L122.299 606.298L89.7104 625.582L90.1143 663.453Z",
    fill: "url(#paint0_linear_59_600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.631 603.933L156.628 622.514L189.217 603.23L188.813 565.359L155.817 546.779L123.224 566.068L123.631 603.933Z",
    fill: "url(#paint1_linear_59_600)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.148 544.414L190.144 562.995L222.733 543.711L222.329 505.84L189.333 487.259L156.741 506.549L157.148 544.414Z",
    fill: "url(#paint2_linear_59_600)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.665 484.894L223.661 503.475L256.25 484.191L255.843 446.326L222.847 427.745L190.258 447.029L190.665 484.894Z",
    fill: "url(#paint3_linear_59_600)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.249 187.297L391.245 205.878L423.834 186.593L423.427 148.728L390.431 130.147L357.842 149.431L358.249 187.297Z",
    fill: "url(#paint4_linear_59_600)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.766 127.777L424.762 146.358L457.351 127.074L456.944 89.2087L423.948 70.6278L391.359 89.9121L391.766 127.777Z",
    fill: "url(#paint5_linear_59_600)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.228 425.292L257.224 443.873L289.816 424.583L289.409 386.718L256.413 368.137L223.824 387.422L224.228 425.292Z",
    fill: "url(#paint6_linear_59_600)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.745 365.773L290.741 384.354L323.33 365.07L322.926 327.199L289.93 308.618L257.338 327.908L257.745 365.773Z",
    fill: "url(#paint7_linear_59_600)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.262 306.253L324.258 324.834L356.847 305.55L356.443 267.679L323.447 249.098L290.855 268.388L291.262 306.253Z",
    fill: "url(#paint8_linear_59_600)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.779 246.734L357.775 265.315L390.364 246.03L389.96 208.16L356.964 189.579L324.372 208.869L324.779 246.734Z",
    fill: "url(#paint9_linear_59_600)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3496 663.757L54.3458 682.338L86.9349 663.053L86.5279 625.188L53.5318 606.607L20.9426 625.892L21.3496 663.757Z",
    fill: "url(#paint10_linear_59_600)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8667 604.237L87.8629 622.818L120.452 603.534L120.045 565.669L87.0488 547.088L54.4597 566.372L54.8667 604.237Z",
    fill: "url(#paint11_linear_59_600)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3833 544.718L121.379 563.298L153.969 544.014L153.562 506.149L120.565 487.568L87.9763 506.852L88.3833 544.718Z",
    fill: "url(#paint12_linear_59_600)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 485.198L154.897 503.779L187.486 484.495L187.079 446.63L154.083 428.049L121.493 447.333L121.9 485.198Z",
    fill: "url(#paint13_linear_59_600)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.481 187.606L322.478 206.187L355.07 186.897L354.663 149.032L321.667 130.451L289.078 149.735L289.481 187.606Z",
    fill: "url(#paint14_linear_59_600)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.998 128.086L355.994 146.667L388.583 127.383L388.179 89.5123L355.183 70.9314L322.591 90.2211L322.998 128.086Z",
    fill: "url(#paint15_linear_59_600)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M356.706 67.341L389.702 85.922L422.291 66.6378L421.884 28.7727L388.888 10.1918L356.299 29.476L356.706 67.341Z",
    fill: "url(#paint16_linear_59_600)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.463 425.596L188.46 444.177L221.049 424.893L220.642 387.028L187.646 368.447L155.056 387.731L155.463 425.596Z",
    fill: "url(#paint17_linear_59_600)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188.98 366.076L221.977 384.657L254.566 365.373L254.159 327.508L221.163 308.927L188.573 328.211L188.98 366.076Z",
    fill: "url(#paint18_linear_59_600)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.497 306.557L255.493 325.138L288.082 305.854L287.675 267.988L254.679 249.408L222.09 268.692L222.497 306.557Z",
    fill: "url(#paint19_linear_59_600)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.014 247.037L289.01 265.618L321.599 246.334L321.192 208.469L288.196 189.888L255.607 209.172L256.014 247.037Z",
    fill: "url(#paint20_linear_59_600)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.69 663.766L192.687 682.347L225.276 663.062L224.869 625.197L191.873 606.616L159.283 625.901L159.69 663.766Z",
    fill: "url(#paint21_linear_59_600)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.208 604.246L226.204 622.827L258.793 603.543L258.386 565.678L225.39 547.097L192.801 566.381L193.208 604.246Z",
    fill: "url(#paint22_linear_59_600)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M226.724 544.727L259.72 563.308L292.309 544.023L291.902 506.158L258.906 487.577L226.317 506.862L226.724 544.727Z",
    fill: "url(#paint23_linear_59_600)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260.241 485.207L293.237 503.788L325.827 484.504L325.419 446.639L292.423 428.058L259.834 447.342L260.241 485.207Z",
    fill: "url(#paint24_linear_59_600)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M427.822 187.615L460.818 206.196L493.411 186.906L493.004 149.041L460.007 130.46L427.418 149.744L427.822 187.615Z",
    fill: "url(#paint25_linear_59_600)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M461.339 128.095L494.335 146.676L526.927 127.387L526.52 89.5215L493.524 70.9406L460.935 90.2249L461.339 128.095Z",
    fill: "url(#paint26_linear_59_600)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.18 725.051L158.176 743.631L190.765 724.347L190.358 686.482L157.362 667.901L124.773 687.185L125.18 725.051Z",
    fill: "url(#paint27_linear_59_600)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M230.349 784.274L263.345 802.855L295.934 783.571L295.527 745.706L262.531 727.125L229.942 746.409L230.349 784.274Z",
    fill: "url(#paint28_linear_59_600)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M335.848 844.675L368.844 863.256L401.433 843.972L401.026 806.107L368.03 787.526L335.441 806.81L335.848 844.675Z",
    fill: "url(#paint29_linear_59_600)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M440.917 905.841L473.913 924.422L506.505 905.132L506.098 867.267L473.102 848.686L440.513 867.97L440.917 905.841Z",
    fill: "url(#paint30_linear_59_600)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M546.086 965.064L579.083 983.645L611.675 964.356L611.268 926.49L578.272 907.91L545.683 927.194L546.086 965.064Z",
    fill: "url(#paint31_linear_59_600)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M648.035 1026.46L681.031 1045.04L713.62 1025.75L713.213 987.89L680.217 969.309L647.628 988.593L648.035 1026.46Z",
    fill: "url(#paint32_linear_59_600)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M293.804 425.605L326.8 444.186L359.389 424.902L358.982 387.037L325.986 368.456L293.397 387.74L293.804 425.605Z",
    fill: "url(#paint33_linear_59_600)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M327.321 366.086L360.317 384.666L392.907 365.382L392.5 327.517L359.503 308.936L326.914 328.22L327.321 366.086Z",
    fill: "url(#paint34_linear_59_600)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M360.838 306.566L393.835 325.147L426.424 305.863L426.017 267.998L393.021 249.417L360.431 268.701L360.838 306.566Z",
    fill: "url(#paint35_linear_59_600)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M394.355 247.046L427.351 265.627L459.94 246.343L459.533 208.478L426.537 189.897L393.948 209.181L394.355 247.046Z",
    fill: "url(#paint36_linear_59_600)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.107 723.569L228.103 742.15L260.692 722.866L260.285 685.001L227.289 666.42L194.7 685.704L195.107 723.569Z",
    fill: "url(#paint37_linear_59_600)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M228.624 664.05L261.62 682.631L294.209 663.346L293.802 625.481L260.806 606.9L228.217 626.185L228.624 664.05Z",
    fill: "url(#paint38_linear_59_600)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M262.141 604.53L295.137 623.111L327.726 603.827L327.319 565.962L294.323 547.381L261.734 566.665L262.141 604.53Z",
    fill: "url(#paint39_linear_59_600)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M295.658 545.011L328.654 563.592L361.243 544.307L360.836 506.442L327.84 487.861L295.251 507.146L295.658 545.011Z",
    fill: "url(#paint40_linear_59_600)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M463.239 247.418L496.235 265.999L528.824 246.715L528.42 208.844L495.424 190.263L462.832 209.553L463.239 247.418Z",
    fill: "url(#paint41_linear_59_600)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M496.756 187.899L529.752 206.48L562.341 187.196L561.937 149.325L528.941 130.744L496.349 150.034L496.756 187.899Z",
    fill: "url(#paint42_linear_59_600)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M329.221 485.409L362.217 503.99L394.806 484.705L394.399 446.84L361.403 428.259L328.814 447.543L329.221 485.409Z",
    fill: "url(#paint43_linear_59_600)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M362.738 425.889L395.734 444.47L428.323 425.186L427.916 387.321L394.92 368.74L362.331 388.024L362.738 425.889Z",
    fill: "url(#paint44_linear_59_600)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M396.255 366.369L429.251 384.95L461.84 365.666L461.433 327.801L428.437 309.22L395.848 328.504L396.255 366.369Z",
    fill: "url(#paint45_linear_59_600)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M429.772 306.85L462.768 325.431L495.357 306.147L494.95 268.281L461.954 249.701L429.365 268.985L429.772 306.85Z",
    fill: "url(#paint46_linear_59_600)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M265.192 724.176L298.188 742.756L330.78 723.467L330.373 685.602L297.377 667.021L264.788 686.305L265.192 724.176Z",
    fill: "url(#paint47_linear_59_600)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M298.709 664.656L331.705 683.237L364.294 663.953L363.89 626.082L330.894 607.501L298.302 626.791L298.709 664.656Z",
    fill: "url(#paint48_linear_59_600)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M332.226 605.137L365.222 623.717L397.811 604.433L397.407 566.563L364.411 547.982L331.819 567.271L332.226 605.137Z",
    fill: "url(#paint49_linear_59_600)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365.743 545.617L398.739 564.198L431.328 544.914L430.921 507.049L397.925 488.468L365.336 507.752L365.743 545.617Z",
    fill: "url(#paint50_linear_59_600)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M533.327 248.019L566.323 266.6L598.912 247.316L598.505 209.451L565.509 190.87L532.92 210.154L533.327 248.019Z",
    fill: "url(#paint51_linear_59_600)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M566.844 188.5L599.84 207.081L632.429 187.796L632.022 149.931L599.026 131.35L566.437 150.635L566.844 188.5Z",
    fill: "url(#paint52_linear_59_600)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M399.306 486.015L432.302 504.596L464.894 485.306L464.487 447.441L431.491 428.86L398.902 448.144L399.306 486.015Z",
    fill: "url(#paint53_linear_59_600)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M432.823 426.495L465.819 445.076L498.411 425.787L498.004 387.922L465.008 369.341L432.419 388.625L432.823 426.495Z",
    fill: "url(#paint54_linear_59_600)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M466.339 366.976L499.336 385.557L531.925 366.273L531.521 328.402L498.525 309.821L465.932 329.111L466.339 366.976Z",
    fill: "url(#paint55_linear_59_600)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M499.856 307.456L532.853 326.037L565.442 306.753L565.038 268.882L532.042 250.302L499.449 269.591L499.856 307.456Z",
    fill: "url(#paint56_linear_59_600)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M300.603 783.976L333.599 802.557L366.188 783.273L365.784 745.402L332.788 726.821L300.196 746.111L300.603 783.976Z",
    fill: "url(#paint57_linear_59_600)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M334.12 724.456L367.116 743.037L399.705 723.753L399.298 685.888L366.302 667.307L333.713 686.591L334.12 724.456Z",
    fill: "url(#paint58_linear_59_600)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M367.637 664.937L400.633 683.518L433.222 664.234L432.815 626.368L399.819 607.787L367.23 627.072L367.637 664.937Z",
    fill: "url(#paint59_linear_59_600)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M401.153 605.417L434.149 623.998L466.739 604.714L466.332 566.849L433.335 548.268L400.746 567.552L401.153 605.417Z",
    fill: "url(#paint60_linear_59_600)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M568.738 307.82L601.734 326.401L634.323 307.116L633.916 269.251L600.92 250.67L568.331 269.955L568.738 307.82Z",
    fill: "url(#paint61_linear_59_600)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M602.254 248.3L635.251 266.881L667.84 247.597L667.433 209.732L634.437 191.151L601.847 210.435L602.254 248.3Z",
    fill: "url(#paint62_linear_59_600)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M434.717 545.815L467.713 564.396L500.302 545.112L499.898 507.241L466.902 488.66L434.31 507.95L434.717 545.815Z",
    fill: "url(#paint63_linear_59_600)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M468.233 486.296L501.23 504.877L533.819 485.593L533.412 447.727L500.416 429.147L467.826 448.431L468.233 486.296Z",
    fill: "url(#paint64_linear_59_600)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M501.751 426.776L534.747 445.357L567.336 426.073L566.929 388.208L533.933 369.627L501.344 388.911L501.751 426.776Z",
    fill: "url(#paint65_linear_59_600)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M535.267 367.257L568.263 385.838L600.852 366.553L600.445 328.688L567.449 310.107L534.86 329.392L535.267 367.257Z",
    fill: "url(#paint66_linear_59_600)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M370.185 784.292L403.181 802.873L435.77 783.588L435.363 745.723L402.367 727.142L369.778 746.427L370.185 784.292Z",
    fill: "url(#paint67_linear_59_600)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M403.702 724.772L436.698 743.353L469.287 724.069L468.88 686.204L435.884 667.623L403.295 686.907L403.702 724.772Z",
    fill: "url(#paint68_linear_59_600)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M437.218 665.253L470.214 683.834L502.804 664.549L502.397 626.684L469.4 608.103L436.811 627.388L437.218 665.253Z",
    fill: "url(#paint69_linear_59_600)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M470.735 605.733L503.732 624.314L536.321 605.03L535.914 567.165L502.917 548.584L470.328 567.868L470.735 605.733Z",
    fill: "url(#paint70_linear_59_600)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M638.316 308.141L671.313 326.722L703.902 307.438L703.498 269.567L670.502 250.986L637.909 270.276L638.316 308.141Z",
    fill: "url(#paint71_linear_59_600)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M671.834 248.622L704.83 267.202L737.419 247.918L737.015 210.048L704.019 191.467L671.426 210.756L671.834 248.622Z",
    fill: "url(#paint72_linear_59_600)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M504.299 546.131L537.295 564.712L569.884 545.428L569.477 507.563L536.481 488.982L503.892 508.266L504.299 546.131Z",
    fill: "url(#paint73_linear_59_600)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M537.815 486.612L570.812 505.193L603.401 485.908L602.994 448.043L569.998 429.462L537.408 448.746L537.815 486.612Z",
    fill: "url(#paint74_linear_59_600)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M571.333 427.092L604.329 445.673L636.918 426.389L636.511 388.524L603.515 369.943L570.926 389.227L571.333 427.092Z",
    fill: "url(#paint75_linear_59_600)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M604.849 367.572L637.845 386.153L670.434 366.869L670.027 329.004L637.031 310.423L604.442 329.707L604.849 367.572Z",
    fill: "url(#paint76_linear_59_600)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M406.107 844.38L439.104 862.961L471.693 843.677L471.286 805.812L438.29 787.231L405.7 806.515L406.107 844.38Z",
    fill: "url(#paint77_linear_59_600)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M439.624 784.861L472.62 803.442L505.209 784.157L504.802 746.292L471.806 727.711L439.217 746.996L439.624 784.861Z",
    fill: "url(#paint78_linear_59_600)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M473.141 725.341L506.137 743.922L538.726 724.638L538.319 686.773L505.323 668.192L472.734 687.476L473.141 725.341Z",
    fill: "url(#paint79_linear_59_600)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M506.658 665.822L539.654 684.403L572.243 665.118L571.836 627.253L538.84 608.672L506.251 627.957L506.658 665.822Z",
    fill: "url(#paint80_linear_59_600)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M674.239 368.229L707.235 386.81L739.825 367.526L739.418 329.661L706.421 311.08L673.832 330.364L674.239 368.229Z",
    fill: "url(#paint81_linear_59_600)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M707.756 308.71L740.752 327.291L773.341 308.007L772.934 270.141L739.938 251.561L707.349 270.845L707.756 308.71Z",
    fill: "url(#paint82_linear_59_600)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M540.221 606.22L573.217 624.801L605.806 605.516L605.399 567.651L572.403 549.07L539.814 568.355L540.221 606.22Z",
    fill: "url(#paint83_linear_59_600)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M573.738 546.7L606.734 565.281L639.323 545.997L638.916 508.132L605.92 489.551L573.331 508.835L573.738 546.7Z",
    fill: "url(#paint84_linear_59_600)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M607.255 487.18L640.251 505.761L672.84 486.477L672.433 448.612L639.437 430.031L606.848 449.315L607.255 487.18Z",
    fill: "url(#paint85_linear_59_600)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M640.769 427.666L673.765 446.247L706.357 426.958L705.95 389.093L672.954 370.512L640.365 389.796L640.769 427.666Z",
    fill: "url(#paint86_linear_59_600)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M475.681 844.699L508.677 863.279L541.266 843.995L540.862 806.125L507.866 787.544L475.274 806.833L475.681 844.699Z",
    fill: "url(#paint87_linear_59_600)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M509.197 785.179L542.193 803.76L574.783 784.476L574.379 746.605L541.383 728.024L508.79 747.314L509.197 785.179Z",
    fill: "url(#paint88_linear_59_600)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M542.714 725.659L575.711 744.24L608.3 724.956L607.893 687.091L574.897 668.51L542.307 687.794L542.714 725.659Z",
    fill: "url(#paint89_linear_59_600)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M576.231 666.14L609.227 684.721L641.816 665.437L641.409 627.572L608.413 608.991L575.824 628.275L576.231 666.14Z",
    fill: "url(#paint90_linear_59_600)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M743.815 368.542L776.812 387.123L809.401 367.839L808.994 329.974L775.998 311.393L743.408 330.677L743.815 368.542Z",
    fill: "url(#paint91_linear_59_600)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M777.332 309.023L810.328 327.604L842.917 308.319L842.51 270.454L809.514 251.873L776.925 271.158L777.332 309.023Z",
    fill: "url(#paint92_linear_59_600)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M609.794 606.538L642.791 625.119L675.38 605.835L674.976 567.964L641.98 549.383L609.387 568.673L609.794 606.538Z",
    fill: "url(#paint93_linear_59_600)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M643.311 547.018L676.307 565.599L708.896 546.315L708.489 508.45L675.493 489.869L642.904 509.153L643.311 547.018Z",
    fill: "url(#paint94_linear_59_600)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M676.828 487.499L709.824 506.08L742.413 486.796L742.006 448.93L709.01 430.349L676.421 449.634L676.828 487.499Z",
    fill: "url(#paint95_linear_59_600)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M710.345 427.979L743.341 446.56L775.93 427.276L775.523 389.411L742.527 370.83L709.938 390.114L710.345 427.979Z",
    fill: "url(#paint96_linear_59_600)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M510.951 903.978L543.947 922.559L576.536 903.274L576.129 865.409L543.133 846.828L510.544 866.113L510.951 903.978Z",
    fill: "url(#paint97_linear_59_600)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M544.467 844.458L577.463 863.039L610.053 843.755L609.649 805.884L576.653 787.303L544.06 806.593L544.467 844.458Z",
    fill: "url(#paint98_linear_59_600)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M577.984 784.939L610.981 803.52L643.57 784.235L643.163 746.37L610.167 727.789L577.577 747.074L577.984 784.939Z",
    fill: "url(#paint99_linear_59_600)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M611.501 725.419L644.497 744L677.086 724.716L676.679 686.851L643.683 668.27L611.094 687.554L611.501 725.419Z",
    fill: "url(#paint100_linear_59_600)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M779.085 427.821L812.082 446.402L844.671 427.118L844.264 389.253L811.268 370.672L778.678 389.956L779.085 427.821Z",
    fill: "url(#paint101_linear_59_600)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M812.602 368.302L845.598 386.883L878.187 367.599L877.78 329.733L844.784 311.153L812.195 330.437L812.602 368.302Z",
    fill: "url(#paint102_linear_59_600)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M645.064 665.817L678.061 684.398L710.65 665.114L710.243 627.249L677.247 608.668L644.657 627.952L645.064 665.817Z",
    fill: "url(#paint103_linear_59_600)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M678.581 606.297L711.577 624.878L744.166 605.594L743.762 567.724L710.766 549.143L678.174 568.432L678.581 606.297Z",
    fill: "url(#paint104_linear_59_600)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M712.098 546.778L745.094 565.359L777.683 546.075L777.276 508.21L744.28 489.629L711.691 508.913L712.098 546.778Z",
    fill: "url(#paint105_linear_59_600)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M745.615 487.258L778.611 505.839L811.2 486.555L810.793 448.69L777.797 430.109L745.208 449.393L745.615 487.258Z",
    fill: "url(#paint106_linear_59_600)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M580.527 904.29L613.523 922.871L646.112 903.587L645.705 865.722L612.709 847.141L580.12 866.425L580.527 904.29Z",
    fill: "url(#paint107_linear_59_600)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M614.043 844.771L647.04 863.352L679.629 844.068L679.222 806.202L646.226 787.622L613.636 806.906L614.043 844.771Z",
    fill: "url(#paint108_linear_59_600)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M647.561 785.251L680.557 803.832L713.146 784.548L712.739 746.683L679.743 728.102L647.154 747.386L647.561 785.251Z",
    fill: "url(#paint109_linear_59_600)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M681.077 725.732L714.073 744.313L746.662 725.029L746.255 687.163L713.259 668.583L680.67 687.867L681.077 725.732Z",
    fill: "url(#paint110_linear_59_600)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M848.659 428.14L881.655 446.72L914.244 427.436L913.84 389.566L880.844 370.985L848.252 390.274L848.659 428.14Z",
    fill: "url(#paint111_linear_59_600)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M882.175 368.62L915.171 387.201L947.761 367.917L947.354 330.052L914.357 311.471L881.768 330.755L882.175 368.62Z",
    fill: "url(#paint112_linear_59_600)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M714.641 666.13L747.637 684.711L780.226 665.426L779.819 627.561L746.823 608.981L714.234 628.265L714.641 666.13Z",
    fill: "url(#paint113_linear_59_600)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M748.158 606.61L781.154 625.191L813.743 605.907L813.336 568.042L780.34 549.461L747.751 568.745L748.158 606.61Z",
    fill: "url(#paint114_linear_59_600)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M781.674 547.091L814.67 565.672L847.26 546.387L846.853 508.522L813.856 489.941L781.267 509.226L781.674 547.091Z",
    fill: "url(#paint115_linear_59_600)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M815.191 487.571L848.187 506.152L880.776 486.868L880.369 449.003L847.373 430.422L814.784 449.706L815.191 487.571Z",
    fill: "url(#paint116_linear_59_600)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M616.543 964.214L649.539 982.795L682.128 963.511L681.724 925.64L648.728 907.059L616.135 926.349L616.543 964.214Z",
    fill: "url(#paint117_linear_59_600)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M650.059 904.694L683.055 923.275L715.644 903.991L715.24 866.12L682.244 847.54L649.652 866.829L650.059 904.694Z",
    fill: "url(#paint118_linear_59_600)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M683.576 845.175L716.572 863.756L749.161 844.471L748.754 806.606L715.758 788.025L683.169 807.31L683.576 845.175Z",
    fill: "url(#paint119_linear_59_600)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M717.093 785.655L750.089 804.236L782.678 784.952L782.271 747.087L749.275 728.506L716.686 747.79L717.093 785.655Z",
    fill: "url(#paint120_linear_59_600)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M884.677 488.058L917.673 506.638L950.263 487.354L949.856 449.489L916.859 430.908L884.27 450.192L884.677 488.058Z",
    fill: "url(#paint121_linear_59_600)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M918.194 428.538L951.19 447.119L983.779 427.835L983.372 389.97L950.376 371.389L917.787 390.673L918.194 428.538Z",
    fill: "url(#paint122_linear_59_600)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M750.656 726.053L783.652 744.634L816.242 725.35L815.838 687.479L782.841 668.898L750.249 688.188L750.656 726.053Z",
    fill: "url(#paint123_linear_59_600)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M784.173 666.534L817.169 685.115L849.758 665.83L849.351 627.965L816.355 609.384L783.766 628.669L784.173 666.534Z",
    fill: "url(#paint124_linear_59_600)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M817.69 607.014L850.686 625.595L883.275 606.311L882.868 568.446L849.872 549.865L817.283 569.149L817.69 607.014Z",
    fill: "url(#paint125_linear_59_600)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M851.207 547.495L884.203 566.076L916.792 546.791L916.385 508.926L883.389 490.345L850.8 509.63L851.207 547.495Z",
    fill: "url(#paint126_linear_59_600)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M686.028 964.7L719.024 983.281L751.614 963.997L751.21 926.126L718.214 907.545L685.621 926.835L686.028 964.7Z",
    fill: "url(#paint127_linear_59_600)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M719.545 905.181L752.541 923.762L785.13 904.477L784.723 866.612L751.727 848.031L719.138 867.316L719.545 905.181Z",
    fill: "url(#paint128_linear_59_600)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M753.062 845.661L786.058 864.242L818.647 844.958L818.24 807.093L785.244 788.512L752.655 807.796L753.062 845.661Z",
    fill: "url(#paint129_linear_59_600)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M786.579 786.142L819.575 804.723L852.164 785.438L851.757 747.573L818.761 728.992L786.172 748.277L786.579 786.142Z",
    fill: "url(#paint130_linear_59_600)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M954.163 488.544L987.159 507.125L1019.75 487.841L1019.34 449.975L986.345 431.395L953.756 450.679L954.163 488.544Z",
    fill: "url(#paint131_linear_59_600)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M987.68 429.024L1020.68 447.605L1053.26 428.321L1052.86 390.456L1019.86 371.875L987.273 391.159L987.68 429.024Z",
    fill: "url(#paint132_linear_59_600)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M820.142 726.54L853.138 745.12L885.727 725.836L885.323 687.966L852.327 669.385L819.735 688.674L820.142 726.54Z",
    fill: "url(#paint133_linear_59_600)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M853.659 667.02L886.655 685.601L919.244 666.317L918.837 628.452L885.841 609.871L853.252 629.155L853.659 667.02Z",
    fill: "url(#paint134_linear_59_600)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M887.176 607.501L920.172 626.081L952.761 606.797L952.354 568.932L919.358 550.351L886.769 569.635L887.176 607.501Z",
    fill: "url(#paint135_linear_59_600)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M920.693 547.981L953.689 566.562L986.278 547.278L985.871 509.413L952.875 490.832L920.286 510.116L920.693 547.981Z",
    fill: "url(#paint136_linear_59_600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_59_600",
    x: 117,
    y: 41.8029,
    width: 903,
    height: 903,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72.5,
    result: "effect1_foregroundBlur_59_600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_600",
    x1: 89.7088,
    y1: 625.585,
    x2: 155.701,
    y2: 662.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_600",
    x1: 123.226,
    y1: 566.066,
    x2: 189.218,
    y2: 603.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_600",
    x1: 156.743,
    y1: 506.546,
    x2: 222.735,
    y2: 543.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_600",
    x1: 190.258,
    y1: 447.029,
    x2: 256.25,
    y2: 484.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_600",
    x1: 357.842,
    y1: 149.431,
    x2: 423.834,
    y2: 186.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_600",
    x1: 391.359,
    y1: 89.912,
    x2: 457.351,
    y2: 127.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_600",
    x1: 223.823,
    y1: 387.424,
    x2: 289.815,
    y2: 424.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_600",
    x1: 257.34,
    y1: 327.905,
    x2: 323.332,
    y2: 365.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_600",
    x1: 290.856,
    y1: 268.385,
    x2: 356.849,
    y2: 305.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_600",
    x1: 324.373,
    y1: 208.866,
    x2: 390.366,
    y2: 246.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_600",
    x1: 20.9426,
    y1: 625.892,
    x2: 86.9349,
    y2: 663.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_600",
    x1: 54.4597,
    y1: 566.372,
    x2: 120.452,
    y2: 603.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_600",
    x1: 87.9763,
    y1: 506.852,
    x2: 153.969,
    y2: 544.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_600",
    x1: 121.493,
    y1: 447.333,
    x2: 187.486,
    y2: 484.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_600",
    x1: 289.076,
    y1: 149.738,
    x2: 355.068,
    y2: 186.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_600",
    x1: 322.593,
    y1: 90.2184,
    x2: 388.585,
    y2: 127.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_600",
    x1: 356.299,
    y1: 29.476,
    x2: 422.291,
    y2: 66.6378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_600",
    x1: 155.056,
    y1: 387.731,
    x2: 221.049,
    y2: 424.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_600",
    x1: 188.573,
    y1: 328.211,
    x2: 254.566,
    y2: 365.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_59_600",
    x1: 222.09,
    y1: 268.692,
    x2: 288.082,
    y2: 305.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_59_600",
    x1: 255.607,
    y1: 209.172,
    x2: 321.599,
    y2: 246.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_59_600",
    x1: 159.283,
    y1: 625.901,
    x2: 225.276,
    y2: 663.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_59_600",
    x1: 192.801,
    y1: 566.381,
    x2: 258.793,
    y2: 603.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_59_600",
    x1: 226.317,
    y1: 506.861,
    x2: 292.309,
    y2: 544.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_59_600",
    x1: 259.834,
    y1: 447.342,
    x2: 325.827,
    y2: 484.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_59_600",
    x1: 427.417,
    y1: 149.747,
    x2: 493.409,
    y2: 186.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_59_600",
    x1: 460.933,
    y1: 90.2276,
    x2: 526.926,
    y2: 127.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_59_600",
    x1: 124.773,
    y1: 687.185,
    x2: 190.765,
    y2: 724.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_59_600",
    x1: 229.942,
    y1: 746.409,
    x2: 295.934,
    y2: 783.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_59_600",
    x1: 335.441,
    y1: 806.81,
    x2: 401.433,
    y2: 843.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_59_600",
    x1: 440.511,
    y1: 867.973,
    x2: 506.503,
    y2: 905.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_59_600",
    x1: 545.681,
    y1: 927.197,
    x2: 611.673,
    y2: 964.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_59_600",
    x1: 647.628,
    y1: 988.593,
    x2: 713.62,
    y2: 1025.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_59_600",
    x1: 293.397,
    y1: 387.74,
    x2: 359.389,
    y2: 424.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_59_600",
    x1: 326.914,
    y1: 328.22,
    x2: 392.907,
    y2: 365.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_59_600",
    x1: 360.431,
    y1: 268.701,
    x2: 426.424,
    y2: 305.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_59_600",
    x1: 393.948,
    y1: 209.181,
    x2: 459.94,
    y2: 246.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_59_600",
    x1: 194.7,
    y1: 685.704,
    x2: 260.692,
    y2: 722.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_59_600",
    x1: 228.217,
    y1: 626.185,
    x2: 294.209,
    y2: 663.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_59_600",
    x1: 261.734,
    y1: 566.665,
    x2: 327.726,
    y2: 603.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_59_600",
    x1: 295.251,
    y1: 507.146,
    x2: 361.243,
    y2: 544.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_59_600",
    x1: 462.833,
    y1: 209.55,
    x2: 528.826,
    y2: 246.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_59_600",
    x1: 496.35,
    y1: 150.031,
    x2: 562.343,
    y2: 187.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_59_600",
    x1: 328.814,
    y1: 447.543,
    x2: 394.806,
    y2: 484.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_59_600",
    x1: 362.331,
    y1: 388.024,
    x2: 428.323,
    y2: 425.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_59_600",
    x1: 395.848,
    y1: 328.504,
    x2: 461.84,
    y2: 365.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_59_600",
    x1: 429.364,
    y1: 268.985,
    x2: 495.357,
    y2: 306.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_59_600",
    x1: 264.786,
    y1: 686.308,
    x2: 330.779,
    y2: 723.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_59_600",
    x1: 298.304,
    y1: 626.788,
    x2: 364.296,
    y2: 663.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_59_600",
    x1: 331.82,
    y1: 567.269,
    x2: 397.812,
    y2: 604.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_59_600",
    x1: 365.336,
    y1: 507.752,
    x2: 431.328,
    y2: 544.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_59_600",
    x1: 532.92,
    y1: 210.154,
    x2: 598.912,
    y2: 247.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_59_600",
    x1: 566.437,
    y1: 150.635,
    x2: 632.429,
    y2: 187.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_59_600",
    x1: 398.9,
    y1: 448.147,
    x2: 464.893,
    y2: 485.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_59_600",
    x1: 432.417,
    y1: 388.628,
    x2: 498.41,
    y2: 425.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_59_600",
    x1: 465.934,
    y1: 329.108,
    x2: 531.926,
    y2: 366.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_59_600",
    x1: 499.451,
    y1: 269.588,
    x2: 565.443,
    y2: 306.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_59_600",
    x1: 300.198,
    y1: 746.108,
    x2: 366.19,
    y2: 783.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_59_600",
    x1: 333.713,
    y1: 686.591,
    x2: 399.705,
    y2: 723.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_59_600",
    x1: 367.23,
    y1: 627.072,
    x2: 433.222,
    y2: 664.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_59_600",
    x1: 400.746,
    y1: 567.552,
    x2: 466.739,
    y2: 604.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_59_600",
    x1: 568.331,
    y1: 269.955,
    x2: 634.323,
    y2: 307.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_59_600",
    x1: 601.847,
    y1: 210.435,
    x2: 667.84,
    y2: 247.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_59_600",
    x1: 434.311,
    y1: 507.947,
    x2: 500.304,
    y2: 545.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_59_600",
    x1: 467.826,
    y1: 448.431,
    x2: 533.819,
    y2: 485.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_59_600",
    x1: 501.343,
    y1: 388.911,
    x2: 567.336,
    y2: 426.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_59_600",
    x1: 534.86,
    y1: 329.392,
    x2: 600.852,
    y2: 366.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_59_600",
    x1: 369.778,
    y1: 746.427,
    x2: 435.77,
    y2: 783.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_59_600",
    x1: 403.295,
    y1: 686.907,
    x2: 469.287,
    y2: 724.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_59_600",
    x1: 436.811,
    y1: 627.388,
    x2: 502.804,
    y2: 664.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_59_600",
    x1: 470.328,
    y1: 567.868,
    x2: 536.321,
    y2: 605.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_59_600",
    x1: 637.911,
    y1: 270.273,
    x2: 703.903,
    y2: 307.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_59_600",
    x1: 671.428,
    y1: 210.754,
    x2: 737.42,
    y2: 247.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_59_600",
    x1: 503.892,
    y1: 508.266,
    x2: 569.884,
    y2: 545.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_59_600",
    x1: 537.408,
    y1: 448.747,
    x2: 603.401,
    y2: 485.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_59_600",
    x1: 570.926,
    y1: 389.227,
    x2: 636.918,
    y2: 426.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_59_600",
    x1: 604.442,
    y1: 329.707,
    x2: 670.434,
    y2: 366.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_59_600",
    x1: 405.7,
    y1: 806.515,
    x2: 471.693,
    y2: 843.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_59_600",
    x1: 439.217,
    y1: 746.996,
    x2: 505.209,
    y2: 784.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_59_600",
    x1: 472.734,
    y1: 687.476,
    x2: 538.726,
    y2: 724.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_59_600",
    x1: 506.251,
    y1: 627.957,
    x2: 572.243,
    y2: 665.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_59_600",
    x1: 673.832,
    y1: 330.364,
    x2: 739.825,
    y2: 367.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_59_600",
    x1: 707.349,
    y1: 270.845,
    x2: 773.341,
    y2: 308.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_59_600",
    x1: 539.814,
    y1: 568.355,
    x2: 605.806,
    y2: 605.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_59_600",
    x1: 573.331,
    y1: 508.835,
    x2: 639.323,
    y2: 545.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_59_600",
    x1: 606.848,
    y1: 449.315,
    x2: 672.84,
    y2: 486.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_59_600",
    x1: 640.363,
    y1: 389.799,
    x2: 706.355,
    y2: 426.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_59_600",
    x1: 475.275,
    y1: 806.831,
    x2: 541.268,
    y2: 843.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_59_600",
    x1: 508.792,
    y1: 747.311,
    x2: 574.784,
    y2: 784.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_59_600",
    x1: 542.307,
    y1: 687.794,
    x2: 608.3,
    y2: 724.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_59_600",
    x1: 575.824,
    y1: 628.275,
    x2: 641.816,
    y2: 665.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_59_600",
    x1: 743.408,
    y1: 330.677,
    x2: 809.401,
    y2: 367.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_59_600",
    x1: 776.925,
    y1: 271.158,
    x2: 842.917,
    y2: 308.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_59_600",
    x1: 609.389,
    y1: 568.67,
    x2: 675.381,
    y2: 605.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_59_600",
    x1: 642.904,
    y1: 509.153,
    x2: 708.896,
    y2: 546.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_59_600",
    x1: 676.421,
    y1: 449.634,
    x2: 742.413,
    y2: 486.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_59_600",
    x1: 709.938,
    y1: 390.114,
    x2: 775.93,
    y2: 427.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_59_600",
    x1: 510.544,
    y1: 866.113,
    x2: 576.536,
    y2: 903.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_59_600",
    x1: 544.062,
    y1: 806.59,
    x2: 610.054,
    y2: 843.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_59_600",
    x1: 577.577,
    y1: 747.074,
    x2: 643.57,
    y2: 784.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_59_600",
    x1: 611.094,
    y1: 687.554,
    x2: 677.086,
    y2: 724.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_59_600",
    x1: 778.678,
    y1: 389.956,
    x2: 844.671,
    y2: 427.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_59_600",
    x1: 812.195,
    y1: 330.437,
    x2: 878.187,
    y2: 367.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_59_600",
    x1: 644.657,
    y1: 627.952,
    x2: 710.65,
    y2: 665.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_59_600",
    x1: 678.176,
    y1: 568.43,
    x2: 744.168,
    y2: 605.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_59_600",
    x1: 711.691,
    y1: 508.913,
    x2: 777.683,
    y2: 546.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_59_600",
    x1: 745.208,
    y1: 449.393,
    x2: 811.2,
    y2: 486.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_59_600",
    x1: 580.12,
    y1: 866.425,
    x2: 646.112,
    y2: 903.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_59_600",
    x1: 613.636,
    y1: 806.906,
    x2: 679.629,
    y2: 844.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_59_600",
    x1: 647.154,
    y1: 747.386,
    x2: 713.146,
    y2: 784.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_59_600",
    x1: 680.67,
    y1: 687.867,
    x2: 746.662,
    y2: 725.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_59_600",
    x1: 848.253,
    y1: 390.272,
    x2: 914.245,
    y2: 427.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_59_600",
    x1: 881.768,
    y1: 330.755,
    x2: 947.761,
    y2: 367.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_59_600",
    x1: 714.234,
    y1: 628.265,
    x2: 780.226,
    y2: 665.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_59_600",
    x1: 747.751,
    y1: 568.745,
    x2: 813.743,
    y2: 605.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_59_600",
    x1: 781.267,
    y1: 509.226,
    x2: 847.26,
    y2: 546.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_59_600",
    x1: 814.784,
    y1: 449.706,
    x2: 880.776,
    y2: 486.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_59_600",
    x1: 616.137,
    y1: 926.346,
    x2: 682.129,
    y2: 963.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_59_600",
    x1: 649.654,
    y1: 866.827,
    x2: 715.646,
    y2: 903.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_59_600",
    x1: 683.169,
    y1: 807.31,
    x2: 749.161,
    y2: 844.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_59_600",
    x1: 716.686,
    y1: 747.79,
    x2: 782.678,
    y2: 784.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_59_600",
    x1: 884.27,
    y1: 450.192,
    x2: 950.263,
    y2: 487.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_59_600",
    x1: 917.787,
    y1: 390.673,
    x2: 983.779,
    y2: 427.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_59_600",
    x1: 750.251,
    y1: 688.185,
    x2: 816.243,
    y2: 725.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_59_600",
    x1: 783.766,
    y1: 628.669,
    x2: 849.758,
    y2: 665.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_59_600",
    x1: 817.283,
    y1: 569.149,
    x2: 883.275,
    y2: 606.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_59_600",
    x1: 850.8,
    y1: 509.63,
    x2: 916.792,
    y2: 546.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_59_600",
    x1: 685.623,
    y1: 926.832,
    x2: 751.615,
    y2: 963.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_59_600",
    x1: 719.138,
    y1: 867.316,
    x2: 785.13,
    y2: 904.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_59_600",
    x1: 752.655,
    y1: 807.796,
    x2: 818.647,
    y2: 844.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_59_600",
    x1: 786.172,
    y1: 748.277,
    x2: 852.164,
    y2: 785.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_59_600",
    x1: 953.756,
    y1: 450.679,
    x2: 1019.75,
    y2: 487.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_59_600",
    x1: 987.273,
    y1: 391.159,
    x2: 1053.26,
    y2: 428.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_59_600",
    x1: 819.737,
    y1: 688.672,
    x2: 885.729,
    y2: 725.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_59_600",
    x1: 853.252,
    y1: 629.155,
    x2: 919.244,
    y2: 666.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_59_600",
    x1: 886.769,
    y1: 569.635,
    x2: 952.761,
    y2: 606.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_59_600",
    x1: 920.286,
    y1: 510.116,
    x2: 986.278,
    y2: 547.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F859A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F859A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons2);
export default __webpack_public_path__ + "static/media/hexagons2.d658573dde514f79b58d79fb1b1178b9.svg";
export { ForwardRef as ReactComponent };